import { ReactNode, useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { AddRemoveBlock } from '~/components/AddRemoveBlock/AddRemoveBlock';
import { FormInput } from '~/components/FormComponents/FormInput';
import FormGridItem from '~/components/FormComponents/FormGridItem';
import { commonStyles } from '~/theme/styles/commonStyles';

interface TEmailList {
  onlyOneField?: boolean;
  disabled?: boolean;
  section?: string;
  label?: ReactNode;
  onBlur?: () => void;
}

export const EmailList = ({ onlyOneField, disabled, section, label, onBlur }: TEmailList) => {
  const { control } = useFormContext();
  const path = section ? section + '.' : '';
  const { fields, append, remove } = useFieldArray({
    control,
    name: `${path}emailAddress`,
  });

  useEffect(() => {
    if (fields.length === 0) {
      append('');
    }
  }, [fields, append]);

  return (
    <>
      {fields.map((item, index) => (
        <FormGridItem key={item.id} sx={commonStyles.centerFlexContainer}>
          <FormInput
            name={`${path}emailAddress.${index}`}
            label={label ?? 'Адреса електронної пошти'}
            placeholder="Введіть адресу електронної пошти"
            disabled={disabled}
            onBlur={onBlur}
            fullWidth
          />
          {!onlyOneField && (
            <AddRemoveBlock
              add={() => append('')}
              remove={() => remove(index)}
              isPlusShown={fields.length < 16}
              isMinusShown={fields.length > 1}
              sx={{ mt: '12px' }}
              blockName={`${path}emailAddress.${index}`}
            />
          )}
        </FormGridItem>
      ))}
    </>
  );
};
